import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import useCoupon from "./hooks";
import Input from "../Previews/Components/Input";
import * as sc from "./styles";

const Coupon = ({
  organization,
  setShowCoupon,
  selectedChannels,
  lifeTimeBudget,
  onChange,
  isEnabled = true
}) => {
  const { t } = useTranslation();
  const [couponCode, setCouponCode] = useState();

  const {
    validateCoupon,
    validCoupon: coupon,
    deleteCoupon
  } = useCoupon({ organization, selectedChannels, lifeTimeBudget });

  function handleApply() {
    validateCoupon(couponCode);
    setCouponCode();
  }

  useEffect(() => {
    onChange(coupon);
  }, [coupon, onChange]);

  return (
    <>
      <sc.CouponInput disabled={!isEnabled}>
        <Input
          id="promo-code"
          clickIcon={() => setShowCoupon(false)}
          label={
            isEnabled
              ? t("Do you have a Promo Code?")
              : t("Promo codes cannot be redeemed for credit")
          }
          placeholder={t("Enter the code")}
          reset={!coupon?.code}
          onBlur={setCouponCode}
        />

        <sc.Button theme="apply" onClick={handleApply}>
          {t("Apply")}
        </sc.Button>
      </sc.CouponInput>

      {coupon?.code && (
        <sc.CouponApplied>
          <p>
            {coupon.code} ({coupon.discountText})
          </p>
          <sc.Button theme="remove" onClick={deleteCoupon}>
            {t("Remove")}
          </sc.Button>
        </sc.CouponApplied>
      )}
    </>
  );
};

export default Coupon;
